const throttle = (interval, fn) => {
	let ready = true;
	let timer = undefined;

	if (!ready) { return }
	const throttled = () => {
		fn();
		ready = false;
		timer = setTimeout(() => {
			ready = true;
			timer = undefined;
		}, interval);
	}

	throttled.isThrottled = () => timer !== undefined;
	return throttled;
};

export { throttle }
